import React, { Component } from 'react';
import {
  ActionSheet, Toast,
  Button,
} from 'antd-mobile';
import {
  // sendSms,
  // sendMail,
  // openWhatsapp,
  // openMessenger,
  openTwitter,
  openInstagram,
  copyToClip,
  sensorsMonitor,
  $t,
} from '@/utils/utils';
import PrizeMsg from '../map'

const SaSdk = sensorsMonitor();
class InviteFriends extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inviteCode: '',
      canShare: true,
    }
  }

  dataList = [
    { url: 'twitter.webp', title: 'Twitter', label: 'Twitter', },
    { url: 'instagram.webp', title: 'Instagram', label: 'Instagram' },
    { url: 'whatsapp.webp', title: 'WhatsApp', label: 'WhatsApp' },
    { url: 'message.webp', title: 'SMS', label: 'Message' },
    { url: 'mail.webp', title: 'Email', label: 'Mail' },
    { url: 'messenger.webp', title: 'Messenger', label: 'Messenger' },
  ].map(obj => ({
    icon: <img src={ `${ window.$localCdnLink }/icon/${ obj.url }` }
      alt={obj.title}
    />,
    title: obj.label,
    name: obj.title,
  }));

  clickBtn = () => {
    // 仅需记录点击分享操作 无需记录分享到哪个平台
    SaSdk.track('h5_lucky_draws_inviteFriends');

    const Content = this.getSmsContent();
    copyToClip(Content); // 复制内容
    window.android && window.android.clickBanner('app://inviteFriends', 2);
  }

  showShareActionSheet = () => {
    // 仅需记录点击分享操作 无需记录分享到哪个平台
    SaSdk.track('h5_lucky_draws_inviteFriends');
    const Content = this.getSmsContent();

    // 使用app返回的方法弹框分享 前端也要做兼容
    if (window.android && window.android.share) {
      window.android.share(this.props.inviteCode, this.props.inviteText || Content);
      return
    }

    // h5点击内容兼容
    copyToClip(Content); // 复制内容
    ActionSheet.showShareActionSheetWithOptions({
      className: 'mib-action-sheet',
      options: this.dataList,
      message: $t('inviteFriends'),
      cancelButtonText: $t('cancel')
    },
    (buttonIndex) => {
      if (buttonIndex < 0) return

      const data = this.dataList[buttonIndex];
      const { title, name } = data;
      const msg = `Invitation link copied, please open ${ name } and send it`;

      switch (title) {
        case 'Message':
          // sendSms('', Content);
          Toast.info(msg, 5);
          // 复制内容并弹框提示
          break;
        case 'Mail':
          // sendMail('', Content);
          Toast.info(msg, 5);
          break;
        case 'WhatsApp':
          // openWhatsapp('', Content, true);
          Toast.info(msg, 5);
          break;
        case 'Messenger':
          // openMessenger(Content, true);
          Toast.info(msg, 5);
          break;
        case 'Twitter':
          openTwitter('', Content, true);
          break;
        case 'Instagram':
          openInstagram(Content, true);
          break;
        default:
          break;
      }
    });
  }

  getSmsContent () {
    const { app, inviteCode } = this.props;
    const registerLink = `${ window.location.origin }/h5/register/${ app }?inviteCode=${ inviteCode }`

    return `Come and enjoy the loan service with me! Invitation code：${inviteCode},Open link:${ registerLink }`
  }

  render() {
    const { app } = this.props;
    return <div className="invite-btn-wrap">
        <Button
          type="primary"
          onClick={ this.showShareActionSheet }
          className="invite-btn"
        >
        { (PrizeMsg[app] && PrizeMsg[app].inviteBtnMsg) || PrizeMsg['default'].inviteBtnMsg }
      </Button>
    </div>
      
  }
}

export default InviteFriends;
